import React, { useState, useEffect } from 'react';
import { Card, CardActionArea, Typography, Avatar, Box } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsVolleyballIcon from '@mui/icons-material/SportsVolleyball';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import PoolIcon from '@mui/icons-material/Pool';
import SportsIcon from '@mui/icons-material/Sports';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { GiBasketballBall, GiSoccerKick, GiSoccerBall } from 'react-icons/gi';
import { TbKarate } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import SplashScreen from './SplashScreen';
import Diversity3Icon from '@mui/icons-material/Diversity3';

const sportIcons = {
  Football: <GiSoccerBall style={{ color: 'white', fontSize: 40 }} />,
  Basketball: <GiBasketballBall style={{ color: 'white', fontSize: 40 }} />,
  Volleyball: <SportsVolleyballIcon sx={{ color: 'white', fontSize: 40 }} />,
  Athletics: <DirectionsRunIcon sx={{ color: 'white', fontSize: 40 }} />,
  Judo: <TbKarate style={{ color: 'white', fontSize: 40 }} />,
  Badminton: <SportsTennisIcon sx={{ color: 'white', fontSize: 40 }} />,
  Swimming: <PoolIcon sx={{ color: 'white', fontSize: 40 }} />,
  Boxing: <SportsMmaIcon sx={{ color: 'white', fontSize: 40 }} />,
  'Volet Jeunesse': <span style={{ color: 'white', fontSize: 40 }}><Diversity3Icon sx={{ fontSize: 40 }} /></span>,
  Sailing: <DirectionsBoatIcon sx={{ color: 'white', fontSize: 40 }} />,
  Weightlifting: <FitnessCenterIcon sx={{ color: 'white', fontSize: 40 }} />,
};

const translatedNames = {
  Football: 'Football',
  Basketball: 'Basket-ball',
  Volleyball: 'Volley-ball',
  Athletics: 'Athlétisme',
  Judo: 'Judo',
  Badminton: 'Badminton',
  Swimming: 'Natation',
  Boxing: 'Boxe',
  'Beach Soccer': 'Football de plage',
  Sailing: 'Voile',
  Weightlifting: 'Haltérophilie',
};


const SportsList = () => {
  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSports = async () => {
      try {
        setLoading(true);
        const sportsSnapshot = await getDocs(collection(db, 'sports'));
        const sportsData = sportsSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name
        }));
        setSports(sportsData);
        setError('');
      } catch (err) {
        console.error('Error fetching sports data:', err);
        setError('Failed to load sports data');
      } finally {
        setLoading(false);
      }
    };
    fetchSports();
  }, []);

  return (
    <>
      {loading ? (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <SplashScreen />
        </Box>
      ) : (
        <Box>
          {error && (
            <Typography variant="body2" sx={{ color: 'red', mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              py: 2,
              px: 1,
              gap: 1,
              scrollSnapType: 'x mandatory',
              '&::-webkit-scrollbar': {
                height: 8,
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'linear-gradient(159deg, rgba(0,127,255,1) 0%, rgba(42,82,190,1) 100%)',
                borderRadius: 4,
              },
            }}
          >
            {sports.map(sport => (
              <Card
                key={sport.id}
                sx={{
                  flex: '0 0 auto',
                  scrollSnapAlign: 'start',
                  width: 100,
                  bgcolor: 'transparent',
                  boxShadow: 'none',
                }}
              >
                <CardActionArea onClick={() => navigate(`/sport/${sport.id}`)}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        background: 'linear-gradient(159deg, rgba(0,71,171,1) 0%, rgba(28,169,201,1) 100%)',
                        borderRadius: '50%',
                        p: '3px',
                        display: 'inline-block',
                      }}
                    >
                      <Avatar
                        sx={{
                          background: 'rgba(28,169,201,1)',
                          color: 'white',
                          width: 60,
                          height: 60,
                          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                        }}
                      >
                        {sportIcons[sport.name] || <SportsIcon sx={{ fontSize: 30, color: 'white' }} />}
                      </Avatar>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: 'white', mt: 1, fontWeight: 500, textAlign: 'center' }}
                    >
                      {translatedNames[sport.name] || sport.name}
                    </Typography>
                  </Box>
                </CardActionArea>

              </Card>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default SportsList;